import { Grid, Typography, useTheme } from '@mui/material';
import { useHistory } from 'react-router';

const Navigate = ({ steps, fontSize = null }) => {
  const theme = useTheme();
  const history = useHistory();

  const back = () => history.goBack();

  const redirectWithData = (path, data) => {
    history.push({ pathname: path, state: data ?? {} });
  };

  const getTypographyProps = isLast => ({
    sx: {
      fontSize: fontSize || { xs: '16px', sm: '18px' },
      color: isLast ? theme.tertiary || '#000' : '#636466',
      fontWeight: 600,
      lineHeight: { xs: 1, sm: 2.3 },
      display: 'inline-flex',
      alignItems: 'center',
      cursor: !isLast ? 'pointer' : 'default',
      '& > span': !isLast
        ? {
            px: { xs: 0.5, sm: 1 },
            fontSize: { xs: '16px', sm: '18px' },
          }
        : {},
    },
  });

  return (
    <Grid sx={{ lineHeight: 1 }}>
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;
        const handleClick = !isLast
          ? step.navigate
            ? () => redirectWithData(step.navigate, step.data)
            : back
          : undefined;

        return (
          <Typography
            key={`navigate-typography-${index}`}
            {...getTypographyProps(isLast)}
            onClick={handleClick}
          >
            {step.title}
            {!isLast && <span>/</span>}
          </Typography>
        );
      })}
    </Grid>
  );
};

export default Navigate;
